import React from "react";

import colors from "../../../utils/colors";
import BaseContainer from "../../../ui/BaseContainer";
import { media } from "../../../utils/uiSizes";

const Base = BaseContainer.withComponent("header");

const HeaderWrapper = Base.extend`
  width: 100%;
  color: ${colors.WHITE};
  margin: 0 auto 1.25rem;
  padding: 0 2rem;
  box-sizing: border-box;

  ${media.tablet`
	margin: 0 auto 1.75rem;
	`} p {
    margin-top: 1rem; /* Kampanja 2.10.2017 –: */
    font-size: 1.125rem;
    letter-spacing: 0.125em;
    text-transform: uppercase;
  }
`;

const PageHeader = props => {
  const { title, subTitle } = props;

  return (
    <HeaderWrapper>
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      {subTitle && <p>{subTitle}</p>}
    </HeaderWrapper>
  );
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/modules/pages/components/PageHeader.js